import { trackAnalyticsNew, toSlug } from '../../../../lib/utils';

export const getFooterAnalytics = ({ analyticsSlug, text, url }) => trackAnalyticsNew({
  url,
  location: 'page:footer',
  name: analyticsSlug || toSlug(text),
});
